import { css } from 'styled-components';

export const color = {
  // primary
  primary: '#3C72FF',
  primaryBg: '#f5f8ff',
  primaryDark: '#292c35',
  primaryLight: '#e3e9fa',

  // gray
  gray900: '#222222',
  gray850: '#474747',
  gray820: '#3c3c47',
  gray800: '#3d3d3d',
  gray750: '#444444',
  gray700: '#585858',
  gray650: '#696f74',
  gray600: '#737373',
  gray550: '#545454',
  gray520: '#929292',
  gray500: '#8e8e8e',
  gray470: '#87959e',
  gray450: '#98a2b3',
  gray400: '#a9a9a9',
  gray350: '#cccccc',
  gray300: '#c4c4c4',
  gray200: '#dfdfdf',
  gray180: '#edeff1',
  gray150: '#e5e7eb',
  gray120: '#ebebeb',
  gray100: '#efefef',
  gray90: '#f4f4f4',
  gray80: '#f7f8f9',
  gray70: '#fafafa',
  gray50: '#fbfbfb',
  gray30: '#0F0F0F',

  // blueGray
  blueGray25: '#fafafc',
  blueGray50: '#f8f9fc',
  blueGray100: '#eaecf5',
  blueGray200: '#c8cce5',
  blueGray300: '#9ea5d1',
  blueGray400: '#717bbc',
  blueGray450: '#426fe4',
  blueGray500: '#4e5ba6',
  blueGray600: '#3e4784',
  blueGray650: '#344054',
  blueGray700: '#363f72',
  blueGray800: '#293056',
  blueGray900: '#101232',
  blueGray950: '#0d0f1c',

  // blue
  blue300: '#2b99ff',
  blue400: '#536dfe',
  blue900: '#000AFF',

  // red
  red500: '#ef4444',
  red600: '#e7290f',
  red700: '#ee4d4d',
  red900: '#e6290e',

  // orange
  orange400: '#f67f20',
  orange500: '#eb8a1c',

  // yellow
  yellow100: '#ffb63c',
  yellow400: '#f3ae2e',
  yellow500: '#f59e0b',
  yellow900: '#e18700',

  // green / purple / pink
  green500: '#16c174',
  purple500: '#9f4ded',
  pink500: '#d50ee6',

  // monochrome
  white: '#ffffff',
  black: '#000000',

  // brand
  brand: {
    kakao: '#FEE500',
    naver: '#03C75A',
    google: '#EBEBEB',
  },

  // info message colors
  infoBg: '#fffae4',
  infoBorder: '#f9eed1',
  infoText: '#4d3900',

  // shadow
  shadow: '0 4px 10px rgba(0, 0, 0, 0.08)',
  shadowLight: '0 2px 3px 0 rgba(0, 0, 0, 0.1)',
  shadowHover: '0 8px 15px rgba(0, 0, 0, 0.10)',


};

const necessary = css`
  &:after {
    display: inline-block;
    content: '*';
    color: ${({ theme }) => theme.color.primary};
  }
`;

export const theme = {
  color,
  necessary,
};
export default theme;
